export default __webpack_public_path__ + "static/flammable_b.3a7e1d88c99d53cb9b872b8fb0920851.png";